import { render, staticRenderFns } from "./SettingsAddressbook.vue?vue&type=template&id=5058c295&scoped=true&"
import script from "./SettingsAddressbook.vue?vue&type=script&lang=js&"
export * from "./SettingsAddressbook.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAddressbook.vue?vue&type=style&index=0&id=5058c295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5058c295",
  null
  
)

export default component.exports